import type { ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";
import { usePlans } from "../PlansContext";

interface SectionWrapperProps {
  sectionName: ReactNode;
  children: ReactNode;
}

export const SectionWrapper = ({
  sectionName,
  children,
}: SectionWrapperProps) => {
  const { isRedesignedPlansPage, plans } = usePlans();

  const legacyLabelProps = !isRedesignedPlansPage
    ? { color: "text-light", textTransform: "uppercase", weight: "bold" }
    : { weight: "medium" };

  const cols = `grid-cols-${plans.length + 1}`;
  const headerClasses = classNames("grid", cols, "bg-primary", {
    "top-64 sticky": !isRedesignedPlansPage,
  });

  return (
    <div className="bg-primary mb-12">
      <div className={headerClasses}>
        <div className="mb-2">
          <Typography.LabelMd {...legacyLabelProps}>
            {sectionName}
          </Typography.LabelMd>
        </div>
      </div>
      <div className={classNames("grid", cols)}>{children}</div>
    </div>
  );
};
